var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lable-i-group theme-lable-i-group"},_vm._l((_vm.statusList),function(item){return _c('div',{key:item,staticClass:"label-i",staticStyle:{"margin-right":"3px"}},[_vm._v(_vm._s(item))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }